<template>
  <div class="control-select-alt text--primary">
    <!-- dropdown -->
    <div class="dropdown control-select-alt__dropdown">
      <button
        v-if="lazyValue"
        aria-haspopup="true"
        aria-expanded="false"
        data-toggle="dropdown"
        type="button"
        class="dropdown-btn"
      >
        <span class="dropdown-btn__text">{{ lazyValue | lowercaseFirstLetter }}?</span>

        <i class="fas fa-angle-down dropdown-btn__icon" />
      </button>

      <!-- dropdown menu -->
      <ul class="dropdown-menu">
        <li v-for="item in selections" :key="item" :data-value="item" @click="updateLazyValue">
          {{ item }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectFilterAlt',
  filters: {
    lowercaseFirstLetter: (value) => {
      if (!value) return '';

      const newValue = value.toString();
      return newValue.charAt(0).toLowerCase() + newValue.slice(1);
    },
  },
  props: {
    selections: {
      type: Array,
      required: true,
    },
    value: null,
  },
  data() {
    return {
      lazyValue: this.value,
    };
  },
  watch: {
    value(newVal) {
      this.lazyValue = newVal;
    },
  },
  methods: {
    updateLazyValue(e) {
      // get selected value
      const { value } = e.target.dataset;

      // update value
      this.lazyValue = value;
      // emit value
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.control-select-alt {
  display: inline-block;

  &__dropdown {
    display: flex;
    align-items: center;

    .dropdown-btn {
      // h3 style
      font-size: 22px;
      font-weight: 700;
      font-family: "Noto Sans Bold", sans-serif;
      line-height: 1.2;

      &__icon {
        margin-left: 10px;
        vertical-align: bottom;
      }
    }

    // overwrite bootstrap css
    ::v-deep .dropdown-backdrop {
      z-index: 8;
    }

    // inherit UOB CSS
    .dropdown-menu {
      z-index: 9;
      white-space: nowrap;
      padding: 0;

      > li {
        color: #005eb8;
        text-align: left;
        font-size: 15px;
        padding: 15px 15px;
        cursor: pointer;
        font-family: "Noto Sans Bold", sans-serif;
        font-weight: 700;
        margin: 0;

        &:hover,
        &:focus {
          background: #004585;
          color: #fff;
        }
      }
    }
  }
}
</style>
